import { ListBoxChangeEvent } from "primereact/listbox";
import { useState } from "react";
import ProductAPIDataSourceImpl from "../../Data/DataSource/API/ProductAPIDataSource";
import { ProductRepositoryImpl } from "../../Data/Repository/ProductRepositoryImpl";
import { Product } from "../../Domain/Model/Product";
import { Products } from "../../Domain/Model/Products";
import { ProductState } from "../../Domain/Model/ProductState";
import { CreateProduct } from "../../Domain/UseCase/CreateProduct";
import { GetProductById } from "../../Domain/UseCase/GetProductById";
import { GetProducts } from "../../Domain/UseCase/GetProducts";
import { UpdateProduct } from "../../Domain/UseCase/UpdateProduct";
import { UpdateStateProduct } from "../../Domain/UseCase/UpdateStateProduct";
import { UpdateTableProduct } from "../../Domain/UseCase/UpdateTableProduct";
import { UploadProductGallery } from "../../Domain/UseCase/UploadProductGallery";

import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { SetMainImage } from "../../Domain/UseCase/SetMainImage";
import { ViewMainImage } from "../../Domain/UseCase/ViewMainImage";
import { ViewProductGalleryById } from "../../Domain/UseCase/ViewProductGalleryById";
import { DeleteProductGallery } from "../../Domain/UseCase/DeleteProductGallery";


export default function ProductViewModel() {

  const [products, setProducts] = useState<Products[]>([]);
  const [checkedStates, setCheckedStates] = useState<Record<number, boolean>>({});
   

    const productDataSourceImpl = new ProductAPIDataSourceImpl();
    const productRepositoryImpl = new ProductRepositoryImpl(productDataSourceImpl);

    const getProductsUseCase = new GetProducts(productRepositoryImpl);
    const getProductByIdUseCase = new GetProductById(productRepositoryImpl);
    const createProductUseCase = new CreateProduct(productRepositoryImpl);

    const updateProductUseCase = new UpdateProduct(productRepositoryImpl);
    const updateTableProductUseCase = new UpdateTableProduct(productRepositoryImpl);
    const updateStateProductUseCase = new UpdateStateProduct(productRepositoryImpl);
   
    const uploadProductGalleryUseCase = new UploadProductGallery(productRepositoryImpl);
    const viewProductGalleryByIdUseCase = new ViewProductGalleryById(productRepositoryImpl);
    const setMainImageUseCase = new SetMainImage(productRepositoryImpl);
    const viewMainImageUseCase = new ViewMainImage(productRepositoryImpl);
    const deleteProductGalleryUseCase = new DeleteProductGallery(productRepositoryImpl);


    async function getProducts(page: number, size: number, search: string): Promise<{ items: Products[]; totalCount: number }> {
      try {
        const result: PaginationResult<Products> = await getProductsUseCase.invoke(page, size, search );
    
        await setProducts(result.items); // Si quieres mantenerlo en el ViewModel
        setCheckedStates(
          result.items.reduce((acc, product) => {
            acc[product.productId] = product.status === 0;
            return acc;
          }, {} as Record<number, boolean>)
        );
    
        return {
          items: result.items,
          totalCount: result.totalCount, // usar totalCount según tu interfaz
        };
      } catch (error) {
        console.error("Error al obtener productos:", error);
        return { items: [], totalCount: 0 };
      }
    }

      async function getProductById(productId: number) {
        try {
          const productById = await getProductByIdUseCase.invoke(productId);
          if (productById) {
            // console.log("buscando...");
      
            // Convertir string ISO a Date si existe el campo dateLimitDiscount
            return {
              ...productById,
              dateLimitDiscount: productById.dateLimitDiscount
                ? new Date(productById.dateLimitDiscount)
                : null,
            };
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      async function createProduct(data: any) {
        const datos = {
          ...data,
          status: data.status ? 1 : 0,  // Convertir booleano a número
          DateLimitDiscount: data.DateLimitDiscount ? new Date(data.DateLimitDiscount).toISOString() : null // Formato de fecha
      };
        try {
          const createdProduct = await createProductUseCase.invoke(datos);
          if(createdProduct){
            return createdProduct;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }

      async function updateProduct(data: Product) {
        try {
          const updatedProduct = await updateProductUseCase.invoke(data);
          if(updatedProduct){
            console.log("Actualizado");
           return updatedProduct;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      async function UpdateTableProductView(data: Products) {
        try {
          const updatedProducts = await updateTableProductUseCase.invoke(data);
          if(updatedProducts){
            console.log("Actualizado");
            return updatedProducts;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }


      async function updateStateProduct(data: ProductState) {
        try {
          const updatedStateProduct = await updateStateProductUseCase.invoke(data);
          if(updatedStateProduct){
            console.log("Actualizado");
           return updatedStateProduct;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      function onChangeProduct(e: ListBoxChangeEvent) {
        e.preventDefault();
        setProducts(e.target.value);
      }
      const handleSwitchChange = async (checked: boolean, productId: number) => {
         // Guardamos el estado anterior en caso de error
        const previousState = checkedStates[productId];

        // Actualizamos el estado en la UI inmediatamente para una mejor experiencia
        setCheckedStates((prevStates) => ({
          ...prevStates,
          [productId]: checked,
        }));

        const stateUpdate: ProductState = {
          productId: productId,
          status: checked ? 0 : 1,
        };

        const success = await updateStateProduct(stateUpdate);

        if (!success) {
          console.warn("No se pudo actualizar el estado en la base de datos. Revirtiendo cambio...");
          setCheckedStates((prevStates) => ({
            ...prevStates,
            [productId]: previousState,
          }));
        }
      };

      async function uploadtGallery(data: any){
        try {
          const createdProduct = await uploadProductGalleryUseCase.invoke(data);
          if(createdProduct){
            return createdProduct;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }
      async function ViewGalleryById(productId: any){
        try {
          const viewGallery = await viewProductGalleryByIdUseCase.invoke(productId);
          if(viewGallery){
            return viewGallery;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }
      async function SetMainImageGallery(data: any){
        try {
          const viewGallery = await setMainImageUseCase.invoke(data);
          
          if(viewGallery){
            return viewGallery;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }
      async function MainImage(productId: any){
        try {
          const viewGallery = await viewMainImageUseCase.invoke(productId);
          
          if(viewGallery){
            return viewGallery;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }
      
      async function deleteProductGallery(id: number){
        try {
          const response = await deleteProductGalleryUseCase.invoke(id);
          if(response){
            return response;
          }
        } catch (e) {
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }

      return {
        getProducts,
        getProductById,
        createProduct,
        updateProduct,
        UpdateTableProductView,
        onChangeProduct,
        products,
        checkedStates,
        handleSwitchChange,
        uploadtGallery,
        ViewGalleryById,
        SetMainImageGallery,
        MainImage,
        deleteProductGallery
      };
}